module.exports = __webpack_public_path__ + "static/test-fc6b644af32a9687ea7fbbaaa0c6ea5b.jpg";